export type ChipOption = { value: string; label: string; count?: number; title?: string };

type Props = {
  options: ChipOption[];
  value: string[] | undefined;
  onChange: (next: string[] | undefined) => void;
  label: string;
};

/** Multi-select as toggle chips. An empty selection means "any". */
export function ChipSet({ options, value, onChange, label }: Props) {
  const selected = new Set(value ?? []);
  const toggle = (v: string) => {
    const next = new Set(selected);
    if (next.has(v)) next.delete(v);
    else next.add(v);
    onChange(next.size === 0 ? undefined : [...next]);
  };
  return (
    <fieldset className="flex flex-wrap gap-1 border-0 p-0 m-0">
      <legend className="sr-only">{label}</legend>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          className="chip"
          aria-pressed={selected.has(o.value)}
          onClick={() => toggle(o.value)}
          title={o.title}
        >
          {o.label}
          {o.count !== undefined ? (
            <span className="num" style={{ color: "var(--muted-2)" }}>
              {o.count}
            </span>
          ) : null}
        </button>
      ))}
    </fieldset>
  );
}
